import { t } from 'i18n';
import { Caption, CustomLink, styled, Tag, ThemeProps } from '@teko/ds-desktop';
import { useGlobalData, useProductDetailState } from 'contexts';
import React from 'react';
import { isDisplayUomByTenant } from 'helpers';

export const ProductHeader: React.FC = () => {
  const { product, stockAvailable } = useProductDetailState();
  const { tenant, uomCodeToDisplayDecimalQuantity } = useGlobalData();
  const brandCode = product?.brand?.code;
  const { barcode } = product || {};

  const renderBrand = () => {
    if (!brandCode || brandCode === 'no-brand')
      return <Brand>{product?.brand?.name}</Brand>;
    return (
      <CustomLink
        href={{
          pathname: '/brands/[brandId]',
          query: {
            brandId: brandCode,
          },
        }}
        as={{
          pathname: `/${brandCode}-brand.${brandCode}`,
        }}
      >
        <Brand>{product?.brand?.name}</Brand>
      </CustomLink>
    );
  };
  return (
    <div>
      <Title>
        {stockAvailable === 0 && (
          <StyledTag variant="link" content={t('Liên hệ đặt hàng')} />
        )}
        {product?.displayName || product?.name}
      </Title>
      <div>
        <Caption
          level={1}
          weight="regular"
          color="textSecondary"
          style={{ fontSize: '14px', marginTop: '-4px' }}
        >
          {t('Thương hiệu')} {renderBrand()}
          <Divider /> SKU: {product?.sellerSku || product?.sku}
          {barcode && (
            <>
              <Divider /> {t('Mã vạch')}: &nbsp;
              {barcode.substring(barcode.length - 6, barcode.length)}
            </>
          )}
        </Caption>
      </div>

      {isDisplayUomByTenant(tenant) && !!product?.uomRatio ? (
        <Caption
          level={1}
          weight="regular"
          color="textSecondary"
          style={{ fontSize: '14px', margin: '16px 0' }}
        >
          ĐVT:{' '}
          {uomCodeToDisplayDecimalQuantity !== product.uomCode
            ? `${product.uomRatio < 1 ? 1 : product.uomRatio} `
            : ''}
          {product.uomName}
        </Caption>
      ) : null}
    </div>
  );
};

const Title = styled.h1`
  font-size: 24px;
  line-height: 1.33;
`;

const StyledTag = styled(Tag)`
  position: relative;
  bottom: 4px;
  margin-right: 4px;
`;

const Divider = styled.span`
  ::before {
    content: '|';
    margin: 0 8px;
  }
`;

const Brand = styled.span(
  ({ theme }: ThemeProps) => `
  color: ${theme?.colors.primary500};
  &:hover{
    color: ${theme?.colors.primary700};
  }
  `,
);
